<div class='assign-tickets-wrapper'>
  <div class='tickets-info-wrapper'>
    <div class='tickets-info-title'>
      {{ "APP.BOOK_EVENT_SLOT.FILL_OUT_TICKET_INFORMATION" | translate }}
    </div>

    <div class='tickets-info-description'>
      {{ getDescription() }}
    </div>
  </div>
  <div class='tickets-wrapper'>
    @for (ticket of ticketOrder?.eventAttendeeTickets; track $index) {
      <app-booking-event-slot-assign-ticket-card
        [index]="$index + 1"
        [eventTicketId]="ticket.eventTicketId"
        [form]="ticketForms.get($index)!"
        [dataFields]='dataFields'
        [slot]='slot'
        [attendeeForm]='attendeeForm'
      />
    }
  </div>
</div>
